import Footer from "@/components/Layouts/Footer";
import Header from "@/components/Layouts/Header";
import NavBar from "@/components/Layouts/NavBar";
import WelcomeSection from "@/components/Layouts/WelcomeSection";
import MyRoutes from "@/components/MyRoutes";
import SignIn from "@/pages/SignIn/SignIn";
import "@/styles/SuperResponsiveTableStyle.css";
import "@/styles/gridLayout.css";
import "@/styles/quill.scss";
import { useEffect, useState } from "react";
import { useFullScreenHandle } from "react-full-screen";
import "react-quill-new/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useLocation } from "react-router-dom";
import "sweetalert2";

// import "react-awesome-lightbox/build/style.css";
import "@/App.css";
import AuthFooter from "@/components/Layouts/AuthFooter";
import ForgotPassword from "@/pages/SignIn/ForgotPassword";
import { ResetPassword } from "@/pages/SignIn/ResetPassword";
// import { UrlLogin } from "@/pages/SignIn/UrlLogin";
import { clearReportSlice } from "@/redux/slices/report.slice";
import { changeFullScreen, changeTheme } from "@/redux/slices/theme.slice";
import "@/styles/layout.css";
import AutoLogoutTimer from "@/utils/AutoLogoutTimer";
import { webFonts } from "@/utils/fonts";
import { flare } from "@flareapp/js";
import { App as AntApp, ConfigProvider, theme } from "antd";
import WebFont from "webfontloader";
import { api } from "./api";
import { setActiveDashboard, setUserDetails } from "./redux/slices/user.slice";

// Custom light themes
const customLightTheme = {
  token: {
    colorPrimary: "#0d6efd",
    colorPrimaryHover: "#0c60d0",
    // colorBgDisabled: "#4b93fd",
    // colorBgContainerDisabled: "#4b93fd",
    colorText: "var(--color-black)",
    colorTextPlaceholder: "var(--color-black)",
    colorIcon: "var(--color-black)",
    colorTextQuaternary: "var(--color-black)",
    colorTextDescription: "var(--color-black)",
    button: {
      colorBgContainerDisabled: "#4b93fd",
      colorTextDisabled: "white",
    },
  },
  components: {
    Select: {
      colorTextPlaceholder: "var(--color-black)",
      colorIcon: "var(--color-black)",
      colorTextQuaternary: "var(--color-black)",
    },
  },
  algorithm: theme.defaultAlgorithm,
};

// custom dark theme
const customDarkTheme = {
  token: {
    colorBgBase: "#101114",
    colorTextBase: "#dee2e6",
    colorWarning: "#ffc107",
    colorError: "#dc3545",
    colorSuccess: "#198754",
    colorPrimary: "#0d6efd",
    colorPrimaryHover: "#0c60d0",
    colorBgDisabled: "#4b93fd",
    colorInfo: "#0dcaf0",
    colorTextPlaceholder: "#dee2e6",
    colorIcon: "#dee2e6",
    colorTextQuaternary: "#dee2e6",
    colorTextDescription: "#dee2e6",
    wireframe: false,
    fontSize: 16,
    sizeStep: 5,
  },
  components: {
    Select: {
      colorTextPlaceholder: "#dee2e6",
      colorIcon: "#dee2e6",
      colorTextQuaternary: "#dee2e6",
    },
  },
  algorithm: [theme.darkAlgorithm, theme.compactAlgorithm],
};

function App() {
  const isLogged = useSelector((state) => state.user?.isLogged || false);
  const { activeDashboard } = useSelector((state) => state?.user);
  const { isNavOpen } = useSelector((state) => state.theme);
  const { currentSite, oldSite } = useSelector((state) => state.report);
  const { isDark } = useSelector((state) => state.theme);
  const toggleShow = () => setShowSidebar(!showSidebar);
  const handle = useFullScreenHandle();
  const dispatch = useDispatch();
  const location = useLocation();
  // const navigate = useNavigate();
  // const { businessUrl } = useParams();

  const [showSidebar, setShowSidebar] = useState(false);

  useEffect(() => {
    if (Object.keys(currentSite).length > 0 || Object.keys(oldSite).length > 0) {
      dispatch(clearReportSlice());
    }
  }, [location]);

  useEffect(() => {
    WebFont.load({
      google: {
        families: webFonts,
      },
    });
  }, []);

  useEffect(() => {
    dispatch(changeFullScreen(handle.active));

    if (handle.active) {
      localStorage.isFullScreenOn = true;
      localStorage.setItem("isFullScreenOn", "y");
    } else {
      localStorage.setItem("isFullScreenOn", "n");
    }
  }, [handle]);

  useEffect(() => {
    if (isDark) {
      document.body.classList.add("dark");
      document.body.setAttribute("data-bs-theme", "dark");
    } else {
      document.body.classList.remove("dark");
      document.body.removeAttribute("data-bs-theme");
    }
  }, [isDark]);

  const getProfile = async () => {
    try {
      const data = await api.get("/user/me");
      dispatch(setUserDetails(data));
      dispatch(setActiveDashboard(activeDashboard || data?.dashboard || ""));
      if (data?.theme) {
        dispatch(changeTheme(data.theme === "dark"));
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };
  useEffect(() => {
    getProfile();
  }, []);

  // close sidebar
  // useEffect(() => {
  //   dispatch(changeNavOpen(false));
  // }, [location?.pathname, location?.search]);

  return (
    <>
      <ConfigProvider theme={isDark ? customDarkTheme : customLightTheme}>
        <AntApp>
          <Routes>
            <Route path="reset-password/:token" element={<ResetPassword />} />
            {/* <Route path="url-login/:token" element={<UrlLogin />} /> */}
            <Route path="*" element={<> </>} />
          </Routes>
          {isLogged ? (
            <div className={`az-body layout_app`}>
              <NavBar />
              <div className={`az-content az-content-dashboard-two mainBody px-3 ${isNavOpen ? "" : "active"}`}>
                <Header toggleShow={toggleShow} handle={handle} />
                <WelcomeSection />
                <MyRoutes handle={handle} />
                <Footer />
              </div>
            </div>
          ) : (
            <>
              <Routes>
                <Route path="/" element={<SignIn />} />
                <Route path="/:businessUrl" element={<SignIn />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/forgot-password/:businessUrl" element={<ForgotPassword />} />
                <Route path="*" element={<> </>} />
              </Routes>
              <AuthFooter />
            </>
          )}
          <AutoLogoutTimer isLogged={isLogged} />
        </AntApp>
      </ConfigProvider>
    </>
  );
}

export default App;
